<template>
  <div class="competitor-info-wrap">
    <LeftSide  @getDetail="getDetail"></LeftSide>
    <DetailContent :detailObj='detailObj'></DetailContent>
  </div>
</template>

<script>
import DetailContent from './components/detailMain/detailContent'
import LeftSide from './components/detailMain/leftSide'

export default {
  data() {
    return {
      detailObj: {}
    }
  },
  components: {
    DetailContent, LeftSide
  },
  methods: {
    getDetail(val) {
      // eslint-disable-next-line prefer-destructuring
      this.detailObj = val[0]
    }
  }
}
</script>

<style scoped lang="scss">

</style>
